;(function () {
  'use strict'

  angular
    .module('docs', ['ngResource', 'settings'])
    .factory('Docs', ['$resource', function ($resource) {
      return $resource(
        CONFIG.api('docs'),
        {},
        {
          query: {method: 'GET', isArray: false},
        },
      )
    }])

  angular
    .module('docs')
    .controller('DocsCtrl', ['$scope', 'Docs', '$timeout', function ($scope, Docs, $timeout) {
      $scope.approved_percents = []

      getDocs()

      function getDocs() {
        Docs.query(
          {id: 'all'},
          function (data) {
            $scope.docs = data.docs

            a4.loaded($scope)

            a4.timeout(
              $timeout,
              $scope,
              function () {
                $.each($scope.docs, function (n, d) {
                  if (d.recipient_count > 0) {
                    $scope.approved_percents[d.id] = Math.round(
                      (d.accepted_count / d.recipient_count) * 100,
                    )
                  }
                })
              },
              200,
            )
          },
          a4.restErrorFactory($scope),
        )
      }
    }])
})()
